<template>
  <div
    class="mt-5 w-full overflow-hidden rounded-[6px] bg-infra-background p-5 text-center"
  >
    Keine Daten verfügbar
  </div>
</template>
